<div class="status-pill-container">
  <div
    class="status-pill"
    [ngClass]="[statusClass, clickable ? 'clickable' : '']"
    [pTooltip]="substatus || null"
    tooltipPosition="top"
    [attr.role]="clickable ? 'button' : null"
    [attr.tabindex]="clickable ? 0 : null"
    (click)="onPillClick($event)"
    (keydown.enter)="onPillClick($any($event))"
    (keydown.space)="onPillClick($any($event))"
    [ngStyle]="
      status === ResourceStatus.PROCESSING && compositeProgressPercent > 0 && compositeProgressPercent < 100
        ? {
            background:
              'linear-gradient(to right, rgba(0, 169, 190, 0.3) ' +
              compositeProgressPercent +
              '%, rgba(0, 169, 190, 0.15) ' +
              compositeProgressPercent +
              '%)',
          }
        : null
    "
  >
    {{ statusLabel }}
  </div>
</div>
